import { supabase } from '../client/supabaseClient';
//TODO: make rpc for this

/**
 * Gets the user's WhatsApp number from their profile.
 * 
 * @returns The phone number with country code or null if not found
 */
export async function getUserPhoneNumber(): Promise<string | null> {
    try {
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) return null;

        const { data, error } = await supabase
            .from('users')
            .select('phone_number')
            .eq('uid', user.id)
            .single();

        if (error) {
            console.error('Error loading phone number:', error);
            return null;
        }

        return data?.phone_number || null;
    } catch (error) {
        console.error('Unexpected error in getUserPhoneNumber:', error);
        return null;
    }
}

/**
 * Updates the user's WhatsApp number in their profile.
 * 
 * @param phoneNumber - The full phone number with country code (e.g., "+91 9876543210")
 * @returns True if successful, false otherwise
 */
export async function updateUserPhoneNumber(phoneNumber: string): Promise<boolean> {
    try {
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) return false;

        const { data, error } = await supabase
            .from('users')
            .update({ phone_number: phoneNumber })
            .eq('uid', user.id)
            .select();

        if (error) {
            console.error('Error saving phone number:', error);
            return false;
        }

        console.log('Phone number saved successfully:', data);
        return true;
    } catch (error) {
        console.error('Unexpected error in updateUserPhoneNumber:', error);
        return false;
    }
}
